import React, { useState } from "react";
import { LocalShipping } from '@mui/icons-material';
import { Card, CardContent, Chip, Divider, Grid, Paper, Typography } from "@mui/material";
import { Root } from "../../Const/componentStyles";
import CachedIcon from '@mui/icons-material/Cached';
import LoadingReport from "./LoadingReport";
import AssessmentIcon from '@mui/icons-material/Assessment';
import StockReport from "./StockReport";
import {
    MDBBtn,
    MDBContainer,
    MDBRow,
    MDBCol,
    MDBCard,
    MDBCardBody,
    MDBInput,
} from 'mdb-react-ui-kit';

type ReportIconsType = {
  [key: string]: JSX.Element;
};

const ReportIcons: ReportIconsType = {
    "Loading / Packing" : <CachedIcon />,
    "Stock Transaction" : <AssessmentIcon />
}

const ReportsMain:React.FC = () => {
    const [showList,setShowList] = useState(false);
    const [selected,setSelected] = useState('');

    const categories = [
        {
            groupName: 'Loading Report',
            items: ["Loading / Packing",],
        },
        {
            groupName: 'Stock Report',
            items: ["Stock Transaction"],
        },
    ];

    const handleSelect = (selected:string) => {
        setSelected(selected);
        setShowList(true);
    }
    
    const handleBack = () => {
        setShowList(false);
        setSelected('');
    }

    return(
        <div className="pt-3 position-relative">
            {!showList?
                <Grid container spacing={2}>
                    {categories.map((group, groupIndex) => (
                        <Grid item xs={12} key={groupIndex}>
                        <Root>
{/*                             <Typography variant="h5" component="div"> */}
{/*                                 <Divider textAlign="left" */}
{/*                                     sx={{ */}
{/*                                         "&::before, &::after": { */}
{/*                                             borderColor: "primary.main", */}
{/*                                         }, */}
{/*                                     }} */}
{/*                                 > */}
{/*                                     <Chip label={group.groupName} color='info' variant="outlined"/> */}
{/*                                 </Divider> */}
{/*                             </Typography> */}
                            <Typography variant="h5" component="div">
                                <Chip label={group.groupName} className="label-ui font-28 fw-bold mb-2 p-0 border-0" variant="outlined"/>
                            </Typography>
                            <MDBCard className="mb-3">
                                <MDBCardBody className="text-white p-3 p-md-5">
                                    <Grid container spacing={2} className={'fade-in'}>
                                        {group.items.map((category, categoryIndex) => (
                                            <Grid item xs={12} sm={6} md={4} lg={3} key={categoryIndex}>
                                                <Card
                                                    onClick={() => handleSelect(category)}
                                                >
                                                <CardContent className="shadow"
                                                    sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center',cursor: 'pointer', }}
                                                >
                                                        <Typography className="text-center" variant="h6" component="div">
                                                            <span className="loading-icon text-theme">{ReportIcons[category]}</span>
                                                            <p className="m-0">{category}</p>
                                                        </Typography>
                                                </CardContent>
                                                </Card>
                                            </Grid>
                                        ))}
                                    </Grid>
                                </MDBCardBody>
                            </MDBCard>
                        </Root>
                    {/* </Paper> */}
                </Grid>
            ))}
            </Grid>
            :
                <div>
                    <div className="mb-3 d-block d-md-flex" style={{alignItems: 'center', justifyContent: 'space-between'}}>
                        <h3 className="label-ui font-28 fw-bold mb-2 p-0 border-0 text-uppercase">Reports</h3>
                        <span>
                            <Chip
                                className="btn-outline-primary"
                                label="Reports List"
                                onClick={handleBack}
                                variant="outlined"
                            />
                        </span>
                    </div>
                    {
                        selected === "Loading / Packing" && <LoadingReport />
                    }
                    {
                        selected === "Stock Transaction" && <StockReport />
                    }
                </div>
            }
        </div>
    )
}

export default ReportsMain